export const FI_HEALTHCARE_WHATSAPP =
  "https://wa.me/573213213635?text=Hola%2C%20soy%20directivo%20del%20sector%20salud%20y%20quiero%20solicitar%20un%20Diagn%C3%B3stico%20Ejecutivo%20de%20Ingenier%C3%ADa%20Financiera%20para%20Organizaciones%20de%20Salud.";

export const financialIntelligenceHealthcare = {
  es: {
    manifesto: "Las organizaciones de salud no necesitan más reportes. Necesitan mejores decisiones.",
    eyebrow: "MEU Aliado · Salud",
    headline: "Ingeniería Financiera para Organizaciones de Salud",
    subtitle:
      "Diseñamos, implementamos y evolucionamos capacidades analíticas, cuantitativas y tecnológicas para que las organizaciones de salud tomen mejores decisiones financieras.",
    ctaPrimary: "Solicitar Diagnóstico Ejecutivo",
    ctaSecondary: "Conocer nuestra metodología",
    heroNote: "Más que consultoría. Más que software. Construimos capacidades permanentes.",
    heroAudience: "Para IPS privadas y clínicas especializadas",
    heroAudienceMeta: "150–500 empleados · 2–10 sedes · Director Financiero",
    heroAudienceTags: ["Liquidez", "Cartera", "Rentabilidad", "Junta Directiva"],
    decisionVisual: {
      title: "Cómo nace una decisión",
      steps: ["Datos", "Señal", "Modelo", "Escenario", "Decisión"],
    },
    problemTitle: "El desafío no es tener datos.",
    problemSubtitle: "Es convertirlos en decisiones.",
    problems: [
      {
        title: "Información fragmentada",
        items: ["ERP", "HIS", "Contabilidad", "Facturación", "Excel"],
      },
      {
        title: "Decisiones reactivas",
        body: "Los problemas financieros se identifican cuando ya ocurrieron.",
      },
      {
        title: "Procesos manuales",
        body: "Gran parte del análisis depende de trabajo repetitivo.",
      },
      {
        title: "Incertidumbre",
        body: "La dirección debe decidir con información incompleta.",
      },
    ],
    thesisTitle:
      "Creemos que el área financiera debe funcionar como un sistema de inteligencia, no solo como un área de control.",
    thesisFlow: ["Datos", "Información", "Análisis", "Modelos", "Escenarios", "Decisiones", "Resultados"],
    buildTitle: "Lo que construimos",
    buildEyebrow: "No servicios. Capacidades.",
    capabilities: [
      {
        title: "Observabilidad Financiera",
        body: "Consolidamos la información crítica para construir una visión única y confiable de la organización.",
        result: "Una sola fuente de verdad para decidir con confianza.",
      },
      {
        title: "Inteligencia Analítica",
        body: "Transformamos datos históricos en explicaciones, proyecciones y escenarios para apoyar la toma de decisiones.",
        result: "Decisiones respaldadas por evidencia, no por intuición.",
      },
      {
        title: "Gestión del Riesgo Financiero",
        body: "Diseñamos modelos para anticipar riesgos de liquidez, cartera, concentración, rentabilidad y sostenibilidad.",
        result: "Identificación temprana de amenazas a la sostenibilidad.",
      },
      {
        title: "Automatización",
        body: "Reducimos procesos manuales mediante herramientas analíticas, modelos y flujos automatizados.",
        result: "Menos tiempo en tareas repetitivas y más tiempo para análisis estratégico.",
      },
      {
        title: "Desarrollo de Capacidades",
        body: "Transferimos conocimiento, metodologías y herramientas para fortalecer al equipo financiero.",
        result: "Una organización más preparada para decidir, mes a mes.",
      },
    ],
    howTitle: "Cómo trabajamos",
    howSubtitle: "Co-desarrollamos con su equipo. No reemplazamos. Potenciamos.",
    howSteps: [
      { title: "Comprender", body: "Conocemos la operación." },
      { title: "Diseñar", body: "Definimos qué capacidades necesita la organización." },
      { title: "Construir", body: "Desarrollamos modelos y herramientas." },
      { title: "Implementar", body: "Integramos las soluciones en la operación." },
      { title: "Evolucionar", body: "Cada mes la organización incorpora nuevas capacidades." },
    ],
    monthlyTitle: "Oficina Externa de Ingeniería Financiera",
    monthlyEyebrow: "Qué recibe cada mes",
    monthlyItems: [
      "Executive Financial Brief",
      "Monitoreo de riesgos",
      "Nuevos modelos cuantitativos",
      "Automatizaciones",
      "Escenarios estratégicos",
      "Comité ejecutivo",
      "Roadmap de evolución",
      "Capacitación al equipo",
    ],
    impactTitle: "Áreas de impacto",
    impactSubtitle: "Qué cambia en la organización",
    impactAreas: [
      "Liquidez",
      "Rentabilidad",
      "Productividad",
      "Planeación",
      "Junta Directiva",
      "Gestión del riesgo",
      "Automatización",
      "Gobierno de datos",
    ],
    examplesTitle: "Ejemplos de capacidades",
    examples: [
      "Forecast de caja",
      "Modelo de recaudo",
      "Modelo de glosas",
      "Rentabilidad por servicio",
      "Stress testing financiero",
      "Simulación de escenarios",
      "Optimización presupuestal",
      "Alertas financieras",
      "Motor de indicadores",
      "Dashboards ejecutivos",
      "Integraciones de datos",
      "Modelos predictivos",
      "IA para análisis financiero",
    ],
    resultsTitle: "Qué cambia si trabaja con nosotros",
    resultsHeaders: ["Capacidad", "Resultado esperado"],
    results: [
      {
        capability: "Forecast de liquidez",
        result: "Mayor visibilidad de caja y menos decisiones de emergencia.",
      },
      {
        capability: "Gestión de riesgo financiero",
        result: "Identificación temprana de amenazas a la sostenibilidad.",
      },
      {
        capability: "Automatización",
        result: "Menos tiempo en tareas manuales y más tiempo para análisis estratégico.",
      },
      {
        capability: "Modelos de rentabilidad",
        result: "Mejor asignación de recursos e inversiones.",
      },
      {
        capability: "Escenarios y simulaciones",
        result: "Decisiones respaldadas por evidencia cuantitativa.",
      },
    ],
    methodTitle: "Healthcare Financial Engineering Framework™",
    methodSubtitle: "Nuestra metodología",
    methodPillars: ["Ver", "Entender", "Decidir", "Ejecutar", "Evolucionar"],
    diffTitle: "La diferencia",
    diffHeaders: ["Consultoría", "Software", "Ingeniería Financiera"],
    diffRows: [
      ["Diagnostica", "Automatiza", "Diseña capacidades"],
      ["Proyecto puntual", "Herramienta", "Evolución continua"],
      ["Recomendaciones", "Reportes", "Modelos y decisiones"],
      ["Finaliza", "Se instala", "Se fortalece mes a mes"],
    ],
    whoTitle: "Para quién está pensado",
    whoSubtitle:
      "Nuestro cliente ideal es una IPS privada o clínica especializada con complejidad operativa real y necesidad de mejores decisiones financieras.",
    idealClient: {
      title: "IPS privada o clínica especializada",
      badge: "Cliente ideal",
      metrics: [
        { label: "Facturación anual", value: "COP $30.000–120.000 millones" },
        { label: "Empleados", value: "150–500" },
        { label: "Número de sedes", value: "2–10" },
      ],
      structureTitle: "Estructura",
      structure: [
        "Tiene Director Financiero o Gerente Administrativo y Financiero.",
        "Tiene ERP y sistema de información clínica.",
        "Usa Power BI o Excel, pero la información sigue fragmentada.",
      ],
      painsTitle: "Dolores",
      pains: ["Crecimiento", "Liquidez", "Cartera", "Rentabilidad", "Necesidad de reportar a Junta Directiva"],
    },
    whoRolesTitle: "Perfiles con los que solemos trabajar",
    who: [
      "CEO",
      "Gerente General",
      "Director Financiero",
      "Junta Directiva",
      "Planeación",
      "Control de Gestión",
      "Transformación Digital",
    ],
    finalLead: "La pregunta no es si necesita más información.",
    finalTitle: "La pregunta es si su organización está preparada para tomar mejores decisiones financieras.",
    finalCta: "Solicitar Diagnóstico Ejecutivo",
    backSalud: "Volver a Salud",
    hub: {
      eyebrow: "Sector especializado",
      title: "Salud",
      subtitle:
        "Soluciones financieras diseñadas para hospitales, IPS, clínicas y grupos de salud.",
      serviceTitle: "Ingeniería Financiera para Organizaciones de Salud",
      serviceBody:
        "Las organizaciones de salud no necesitan más reportes. Necesitan mejores decisiones.",
      serviceCta: "Conocer el servicio",
      back: "Volver a Empresas",
    },
  },
  en: {
    manifesto: "Healthcare organizations don't need more reports. They need better decisions.",
    eyebrow: "MEU Aliado · Healthcare",
    headline: "Financial Engineering for Healthcare Organizations",
    subtitle:
      "We design, implement, and evolve analytical, quantitative, and technological capabilities so healthcare organizations can make better financial decisions.",
    ctaPrimary: "Request Executive Diagnosis",
    ctaSecondary: "See our methodology",
    heroNote: "More than consulting. More than software. We build permanent capabilities.",
    heroAudience: "For private IPS and specialty clinics",
    heroAudienceMeta: "150–500 employees · 2–10 sites · Financial Director",
    heroAudienceTags: ["Liquidity", "Receivables", "Profitability", "Board"],
    decisionVisual: {
      title: "How a decision is born",
      steps: ["Data", "Signal", "Model", "Scenario", "Decision"],
    },
    problemTitle: "The challenge is not having data.",
    problemSubtitle: "It is turning data into decisions.",
    problems: [
      {
        title: "Fragmented information",
        items: ["ERP", "HIS", "Accounting", "Billing", "Excel"],
      },
      {
        title: "Reactive decisions",
        body: "Financial problems are identified only after they have already happened.",
      },
      {
        title: "Manual processes",
        body: "Much of the analysis still depends on repetitive work.",
      },
      {
        title: "Uncertainty",
        body: "Leadership must decide with incomplete information.",
      },
    ],
    thesisTitle:
      "We believe the finance function should operate as an intelligence system — not only as a control area.",
    thesisFlow: ["Data", "Information", "Analysis", "Models", "Scenarios", "Decisions", "Results"],
    buildTitle: "What we build",
    buildEyebrow: "Not services. Capabilities.",
    capabilities: [
      {
        title: "Financial Observability",
        body: "We consolidate critical information to build a single, reliable view of the organization.",
        result: "One trusted source of truth to decide with confidence.",
      },
      {
        title: "Analytical Intelligence",
        body: "We turn historical data into explanations, projections, and scenarios that support decisions.",
        result: "Evidence-backed decisions, not intuition alone.",
      },
      {
        title: "Financial Risk Management",
        body: "We design models to anticipate liquidity, receivables, concentration, profitability, and sustainability risks.",
        result: "Early identification of threats to sustainability.",
      },
      {
        title: "Automation",
        body: "We reduce manual processes through analytical tools, models, and automated workflows.",
        result: "Less time on repetitive tasks and more time for strategic analysis.",
      },
      {
        title: "Capability Development",
        body: "We transfer knowledge, methodologies, and tools to strengthen the finance team.",
        result: "An organization better prepared to decide, month after month.",
      },
    ],
    howTitle: "How we work",
    howSubtitle: "We co-develop with your team. We don't replace. We amplify.",
    howSteps: [
      { title: "Understand", body: "We learn the operation." },
      { title: "Design", body: "We define which capabilities the organization needs." },
      { title: "Build", body: "We develop models and tools." },
      { title: "Implement", body: "We integrate solutions into operations." },
      { title: "Evolve", body: "Every month the organization incorporates new capabilities." },
    ],
    monthlyTitle: "External Financial Engineering Office",
    monthlyEyebrow: "What you receive every month",
    monthlyItems: [
      "Executive Financial Brief",
      "Risk monitoring",
      "New quantitative models",
      "Automations",
      "Strategic scenarios",
      "Executive committee",
      "Evolution roadmap",
      "Team training",
    ],
    impactTitle: "Impact areas",
    impactSubtitle: "What changes in the organization",
    impactAreas: [
      "Liquidity",
      "Profitability",
      "Productivity",
      "Planning",
      "Board",
      "Risk management",
      "Automation",
      "Data governance",
    ],
    examplesTitle: "Capability examples",
    examples: [
      "Cash forecasting",
      "Collections model",
      "Denial model",
      "Profitability by service",
      "Financial stress testing",
      "Scenario simulation",
      "Budget optimization",
      "Financial alerts",
      "KPI engine",
      "Executive dashboards",
      "Data integrations",
      "Predictive models",
      "AI for financial analysis",
    ],
    resultsTitle: "What changes when you work with us",
    resultsHeaders: ["Capability", "Expected outcome"],
    results: [
      {
        capability: "Liquidity forecasting",
        result: "Greater cash visibility and fewer emergency decisions.",
      },
      {
        capability: "Financial risk management",
        result: "Early identification of threats to sustainability.",
      },
      {
        capability: "Automation",
        result: "Less time on manual tasks and more time for strategic analysis.",
      },
      {
        capability: "Profitability models",
        result: "Better allocation of resources and investments.",
      },
      {
        capability: "Scenarios and simulations",
        result: "Decisions backed by quantitative evidence.",
      },
    ],
    methodTitle: "Healthcare Financial Engineering Framework™",
    methodSubtitle: "Our methodology",
    methodPillars: ["See", "Understand", "Decide", "Execute", "Evolve"],
    diffTitle: "The difference",
    diffHeaders: ["Consulting", "Software", "Financial Engineering"],
    diffRows: [
      ["Diagnoses", "Automates", "Designs capabilities"],
      ["One-off project", "Tool", "Continuous evolution"],
      ["Recommendations", "Reports", "Models and decisions"],
      ["Ends", "Gets installed", "Strengthens month after month"],
    ],
    whoTitle: "Who this is for",
    whoSubtitle:
      "Our ideal client is a private IPS or specialty clinic with real operating complexity and a need for better financial decisions.",
    idealClient: {
      title: "Private IPS or specialty clinic",
      badge: "Ideal client",
      metrics: [
        { label: "Annual revenue", value: "COP $30–120 billion" },
        { label: "Employees", value: "150–500" },
        { label: "Number of sites", value: "2–10" },
      ],
      structureTitle: "Structure",
      structure: [
        "Has a Financial Director or Administrative and Financial Manager.",
        "Has an ERP and a clinical information system.",
        "Uses Power BI or Excel, but information is still fragmented.",
      ],
      painsTitle: "Pain points",
      pains: ["Growth", "Liquidity", "Receivables", "Profitability", "Need to report to the Board"],
    },
    whoRolesTitle: "Roles we usually work with",
    who: [
      "CEO",
      "General Manager",
      "Financial Director",
      "Board",
      "Planning",
      "Management Control",
      "Digital Transformation",
    ],
    finalLead: "The question is not whether you need more information.",
    finalTitle: "The question is whether your organization is ready to make better financial decisions.",
    finalCta: "Request Executive Diagnosis",
    backSalud: "Back to Healthcare",
    hub: {
      eyebrow: "Specialized sector",
      title: "Healthcare",
      subtitle:
        "Financial solutions designed for hospitals, IPS, clinics, and healthcare groups.",
      serviceTitle: "Financial Engineering for Healthcare Organizations",
      serviceBody:
        "Healthcare organizations don't need more reports. They need better decisions.",
      serviceCta: "Explore the service",
      back: "Back to Business",
    },
  },
};

export const empresasSectores = {
  es: {
    title: "Sectores especializados",
    subtitle: "Soluciones financieras adaptadas a la realidad operativa de cada industria.",
    explore: "Explorar",
    items: [
      {
        id: "salud",
        title: "Salud",
        description:
          "Las organizaciones de salud no necesitan más reportes. Necesitan mejores decisiones.",
        path: "/empresas/salud/financial-intelligence",
        badge: "Especializado",
      },
      {
        id: "construccion",
        title: "Construcción",
        description:
          "Visibilidad de caja, márgenes por obra y control financiero para constructoras e inmobiliarias.",
        path: "/empresas/construccion",
        badge: "Especializado",
      },
      {
        id: "corporativo",
        title: "Corporativo",
        description:
          "Dirección de innovación financiera, gestión de caja y beneficios para empresas de todos los sectores.",
        path: "/empresas/direccion-de-innovacion-financiera",
        badge: "Transversal",
      },
    ],
  },
  en: {
    title: "Specialized sectors",
    subtitle: "Financial solutions tailored to each industry's operating reality.",
    explore: "Explore",
    items: [
      {
        id: "salud",
        title: "Healthcare",
        description:
          "Healthcare organizations don't need more reports. They need better decisions.",
        path: "/empresas/salud/financial-intelligence",
        badge: "Specialized",
      },
      {
        id: "construccion",
        title: "Construction",
        description:
          "Cash visibility, project margins, and financial control for builders and real-estate groups.",
        path: "/empresas/construccion",
        badge: "Specialized",
      },
      {
        id: "corporativo",
        title: "Corporate",
        description:
          "Financial innovation leadership, cash management, and benefits for companies across sectors.",
        path: "/empresas/direccion-de-innovacion-financiera",
        badge: "Cross-industry",
      },
    ],
  },
};

export const construccionHub = {
  es: {
    eyebrow: "Sector especializado",
    title: "Construcción",
    subtitle:
      "Estamos diseñando inteligencia financiera para constructoras, desarrolladores e inmobiliarias.",
    body:
      "Pronto podrá proyectar caja por obra, detectar desviaciones de margen y priorizar cobranza de avances — con la misma rigurosidad ejecutiva que en Salud.",
    cta: "Quiero ser contactado",
    back: "Volver a Empresas",
    whatsapp:
      "https://wa.me/573213213635?text=Hola%2C%20me%20interesa%20conocer%20las%20soluciones%20financieras%20para%20el%20sector%20Construcci%C3%B3n.",
  },
  en: {
    eyebrow: "Specialized sector",
    title: "Construction",
    subtitle:
      "We are designing financial intelligence for builders, developers, and real-estate groups.",
    body:
      "Soon you will project cash by project, detect margin deviations, and prioritize progress billing — with the same executive rigor as Healthcare.",
    cta: "Contact me",
    back: "Back to Business",
    whatsapp:
      "https://wa.me/573213213635?text=Hello%2C%20I%27m%20interested%20in%20financial%20solutions%20for%20the%20Construction%20sector.",
  },
};
